// Keep in sync with the CLINIC_EDIT_*_MESSAGE constants in
// services/orders/clinic_edit_window.py: the backend refuses a lease or an
// edit with one of these when the clinic can't edit. Each is the backend
// message's first sentence, matched as a prefix. Only the window-closed one,
// on a submit, opens the Edit Window Ended modal.
export const CLINIC_EDIT_WINDOW_CLOSED_MESSAGE =
  "The editing window for this order has ended.";
const CLINIC_EDIT_STATUS_LOCKED_MESSAGE = "This order can no longer be edited.";
const CLINIC_EDIT_ALREADY_SUBMITTED_MESSAGE =
  "You've already edited this order.";
export const CLINIC_EDIT_REFUSAL_MESSAGES = [
  CLINIC_EDIT_WINDOW_CLOSED_MESSAGE,
  CLINIC_EDIT_STATUS_LOCKED_MESSAGE,
  CLINIC_EDIT_ALREADY_SUBMITTED_MESSAGE,
];
